import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ErrorBoundary } from './components/ui/error-boundary'
import { Toaster } from './components/ui/toaster'
import App from './App.tsx'
import './styles/globals.css'

// Display startup branding message
console.log(
  '%c🚀 MindSpire Planner',
  'color: #3b82f6; font-size: 24px; font-weight: bold;'
);
console.log(
  '%c⚡ Intelligent Educational Schedule Management System',
  'color: #6366f1; font-size: 14px;'
);
console.log(
  '%c💼 Powered by Java Mantra Corp.',
  'color: #059669; font-size: 12px; font-weight: bold;'
);
console.log(
  '%c🌐 Visit: https://javamantra.com',
  'color: #0891b2; font-size: 12px;'
);

// Create a client with comprehensive error handling
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes (formerly cacheTime)
      retry: (failureCount, error: any) => {
        // Don't retry on 4xx errors (client errors)
        if (error?.status >= 400 && error?.status < 500) {
          return false
        }
        // Retry up to 2 times for other errors
        return failureCount < 2
      },
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      refetchOnWindowFocus: false,
      onError: (error: any) => {
        console.error('Query Error:', error)
      }
    },
    mutations: {
      retry: false, // Don't retry mutations by default
      onError: (error: any) => {
        console.error('Mutation Error:', error)
      }
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
          <Toaster />
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>,
)
